export default "__VITE_ASSET__Bc9ja3xR__"